<template>
  <div class="ai-customer-guide">
    <div class="setting-knowledge-container">
      <div class="knowledge-management">
        <div class="module-item-style table-data table-box">
          <el-form :model="problemForm">
            <el-form-item v-for="(item, index) in problemForm.titleList" :key="index" :label="index === 0 ? '问题' : ''">
              <div class="problem-input-row">
                <el-input v-model="item.title" placeholder="请输入问题" autocomplete="off"></el-input>
                <el-button v-if="problemForm.titleList.length > 1" type="text" class="problem-input-del"
                  @click="removeProblemItem(index)">删除</el-button>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button v-if="problemForm.titleList.length < 10" type="text" icon="el-icon-plus" @click="addProblemItem">添加问题</el-button>
            </el-form-item>
          </el-form>
          <div class="dialog-footer">
            <el-button type="primary" @click="submitProblemForm">保 存</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ai-customer-guide',
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      problemForm: {
        titleList: [{ title: '' }],
      },
    }
  },
  created() {
    this.getAiCsGuideProblems()
  },
  methods: {
    resetProblemForm() {
      this.problemForm = {
        titleList: [{ title: '' }],
      }
    },
    addProblemItem() {
      this.problemForm.titleList.push({ title: '' })
    },
    removeProblemItem(index) {
      this.problemForm.titleList.splice(index, 1)
    },
    cancelEdit() {
      this.getAiCsGuideProblems()
    },
    submitProblemForm() {
      const problems = []
      for (let i = 0; i < this.problemForm.titleList.length; i++) {
        if (this.$utils.u_isEmpty(this.problemForm.titleList[i].title)) {
          this.$message({
            message: '问题不能为空',
            type: 'error',
          })
          return false
        }
        problems.push(this.problemForm.titleList[i].title)
      }
      this.$http.setAiCsGuideProblems({ problems }).then(res => {
        if (res.status == 1) {
          this.getAiCsGuideProblems()
          this.$message({
            message: res.msg,
            type: 'success',
          })
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
    getAiCsGuideProblems() {
      this.$http.getAiCsGuideProblems({
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      }).then(res => {
        if (res.status == 1) {
          const list = (res.data || []).map(item => ({ title: item.problemText }))
          this.problemForm = {
            titleList: list.length ? list : [{ title: '' }],
          }
        }
      })
    },
  }
}
</script>

<style lang="scss">
.ai-customer-guide {
  background: #fff;

  .setting-knowledge-container {
    margin-top: 15px;
  }

  .dialog-footer {
    text-align: center;
  }

  .problem-input-row {
    display: flex;
    align-items: center;

    .el-input {
      flex: 1;
    }

    .problem-input-del {
      margin-left: 10px;
    }
  }

  .el-form-item__label {
    float: none;
    font-weight: bold;
    color: #333;
  }

  .el-select {
    width: 100%;
  }

}

.knowledge-management {
  .table-data {
    width: 600px;
    position: relative;
  }
}
</style>
